import { writable } from 'svelte/store';
import { supabase } from './db';
export const user = writable(null);
export const initStore = () => {
    user.set(supabase.auth.user());
    supabase.auth.onAuthStateChange((event, session) => {
        user.set(session.user);
    });
};
